type StorageName = 'localStorage' | 'sessionStorage';

// Touching web storage throws when the browser blocks site data, as Safari
// does with all cookies blocked, and some Android WebViews leave it null.
// Callers then get `null` or `false` and behave as if nothing is stored.

/** The stored value, or `null` when the key is unset or storage is unavailable. */
export const readStorage = (name: StorageName, key: string): string | null => {
  try {
    return window[name]?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

/** Whether the value was stored. */
export const writeStorage = (
  name: StorageName,
  key: string,
  value: string,
): boolean => {
  try {
    const storage = window[name];
    if (!storage) return false;
    storage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};
